<template>
    <div>
        <div class="content-wrapper" style="padding-bottom: 0">
            <app-breadcrumb :page-title="data.name" :icon="'package'"/>
            <div><b>{{ $t('team_id') }}: </b>{{ data.id }}</div>
        </div>
        <pinnacle-teams-datatable :team_id='data.id'></pinnacle-teams-datatable>
    </div>
</template>

<script>
    import * as actions from "../../../../Config/ApiUrl";
    import {urlGenerator} from "../../../../Helpers/AxiosHelper";

    export default {
        name: "ViewTeam",
        props: ['data'],
        data() {
            return {
                componentLoader: false,
                preloader: false,
            }
        },
    }
</script>